export const userSettings = {
  theme: 'theme',
  disableEventTheme: 'disableEventTheme',
}
